/**
 * Página de Términos y Condiciones
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './AuthPages.css';
import './TermsPage.css';

function TermsPage() {
  const { t } = useTranslation();

  return (
    <div className="terms-container">
      <div className="terms-card">
        <div className="terms-header">
          <h1>Citame</h1>
          <h2>{t('terms.title')}</h2>
          <p className="terms-updated">{t('terms.lastUpdated', { date: '6 de abril de 2026' })}</p>
        </div>

        <div className="terms-body">
          <section>
            <h3>{t('terms.section1Title')}</h3>
            <p>{t('terms.section1Body')}</p>
          </section>

          <section>
            <h3>{t('terms.section2Title')}</h3>
            <p>{t('terms.section2Body')}</p>
            <ul>
              <li>{t('terms.section2Item1')}</li>
              <li>{t('terms.section2Item2')}</li>
              <li>{t('terms.section2Item3')}</li>
            </ul>
          </section>

          <section>
            <h3>{t('terms.section3Title')}</h3>
            <p>{t('terms.section3Body')}</p>
          </section>

          <section>
            <h3>{t('terms.section4Title')}</h3>
            <p>{t('terms.section4Body')}</p>
          </section>

          <section>
            <h3>{t('terms.section5Title')}</h3>
            <p>{t('terms.section5Body')}</p>
          </section>

          <section>
            <h3>{t('terms.section6Title')}</h3>
            <p>{t('terms.section6Body')}</p>
          </section>
        </div>

        <div className="terms-footer">
          <Link to="/register" className="btn btn-primary">
            {t('terms.backToRegister')}
          </Link>
          <Link to="/login" className="btn btn-ghost">
            {t('terms.backToLogin')}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;
